/**
 * Convocatory Modal Component
 * Handles the opening and closing of the convocatory modal
 */

class ConvocatoryModal {
    constructor() {
        this.modal = document.getElementById('convocatory-modal');
        this.openButton = document.getElementById('open-convocatory-modal');
        this.closeButton = document.getElementById('close-convocatory-modal');
        this.overlay = this.modal?.querySelector('.convocatory-modal__overlay');
        
        this.init();
    }

    init() {
        if (!this.modal || !this.openButton || !this.closeButton) {
            console.warn('Convocatory modal elements not found');
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        // Open modal
        this.openButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        });

        // Close modal - close button
        this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeModal();
        });

        // Close modal - overlay click
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.closeModal();
            }
        });

        // Close modal - ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isModalOpen()) {
                this.closeModal();
            }
        });
    }

    openModal() {
        this.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        
        // Add animation class after display is set
        setTimeout(() => {
            this.modal.classList.add('convocatory-modal--open');
        }, 10);

        // Focus trap - focus on close button
        this.closeButton.focus();
    }

    closeModal() {
        this.modal.classList.remove('convocatory-modal--open');
        
        // Wait for animation to complete before hiding
        setTimeout(() => {
            this.modal.style.display = 'none';
            document.body.style.overflow = '';
        }, 300);

        // Return focus to open button
        this.openButton.focus();
    }

    isModalOpen() {
        return this.modal.style.display === 'flex';
    }
}

// Initialize modal when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new ConvocatoryModal();
});

export default ConvocatoryModal;
